import { render } from "./UserAll.vue?vue&type=template&id=228584c7"
import script from "./UserAll.vue?vue&type=script&lang=js"
export * from "./UserAll.vue?vue&type=script&lang=js"

import "./UserAll.vue?vue&type=style&index=0&id=228584c7&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__